import axios from '../Api/api';

export default function home() {
    return new Promise((resolve, reject) => {
        axios.get("/home/dashboard", {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('authToken')}`,
            },
        })
            .then((response) => {
                resolve(response.data);
            })
            .catch((error) => {
                reject(error);
            });
    });
}
